import React, { useRef,useState,useEffect } from "react";
import { Button } from 'primereact/button';
import GetRequest from "../../service/GetRequest";
import DownloadFileRequest from "../../service/DownloadFileRequest";
import UploadFileRequest from "../../service/UploadFileRequest";
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import 'react-toastify/dist/ReactToastify.css';
import { Toast } from 'primereact/toast';

const UploadProductCSVPopup = () => {
  const toastRef = useRef(null);

    const [branchList, setBranchList] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    const [isFileSelected, setIsFileSelected] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    

    const fetchStoreDetails = () => {
        GetRequest("v1/store-management-service/view/my/store", true)
          .then(response => {
            if (!response || !response.storeBranches || response.storeBranches.length === 0) {
              console.error("Empty response or undefined data for store branches");
            } else {
              setBranchList(response.storeBranches);
              setSelectedBranch(response.storeBranches[0]); // Select the first branch by default
              setSelectedBranchId(response.storeBranches[0].id); //// Select the first branch ID by default
            }
          })
          .catch(error => {
            console.error("Error fetching store details:", error);
          });
      };

    

      const handleUpload = async (file) => {
        try {
          setIsUploading(true);
          UploadFileRequest(`v1/inventory-service/upload/products/excel/${selectedBranchId}`, file, true);
          setIsUploading(false);
          toastRef.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded Successfully' });
        } catch (error) {
          toastRef.current.show({ severity: 'error', summary: 'Error', detail: 'Error Uploading File' });
        }
        setIsUploading(false);
      };

      const handleDownloadExcel = () => {
        DownloadFileRequest('v1/inventory-service/product-format/excel/download', true, 'product_format.xlsx');
      };
    


    
      const customUploadHandler = async (event) => {
        const file = event.files[0];
        setSelectedFile(file);
        setIsFileSelected(true);
      };

      const uploadSelectedFile = () => {
        if (selectedFile) {
          handleUpload(selectedFile);
        }
      };
      

      useEffect(() => {
        fetchStoreDetails();
      }, []);


      const handleBranchChange = (e) => {
        const selectedBranch = branchList.find(branch => branch.id === e.target.value);
        setSelectedBranch(selectedBranch);
        setSelectedBranchId(e.target.value);
        console.log("selected branch city:",selectedBranch.city);
        console.log("Selected branch:", e.value);
    };

  return (
    <div className="flex justify-content-center">
              <Toast ref={toastRef} />
                <div className="flex flex-column ">
                <p className="text-center">
                <h2>Import products via uploading excel sheet</h2>
                <h4>(Suitable for bulk uploading products)</h4>
                    <Button label="Download Excel Format" icon="pi pi-download" iconPos="right" onClick={handleDownloadExcel}/>
                    <br/>
                    <br/></p> 
                    <p className="mb-0">
                        <ol>
                            <li>To upload products in bulk, Download the Excel file above</li>
                            <li>Enter product details such as product name, Category and price in the downloaded file.</li>
                            <li>Upload the file in the button below by choosing branch.</li>
                        </ol>
                </p>               
                
               
            
               
                <p className="mb-10 text-center">
                    In order to upload excel, you have to choose a branch where you wish to add products.
                    <br/><br/><div className="flex-auto mb-1">
                <label htmlFor="stacked-buttons" className="font-bold block mb-2">Choose a Branch</label>
                <Dropdown
                        value={selectedBranchId}
                        options={branchList.map(branch => ({ label: branch.name, value: branch.id }))}
                        onChange={handleBranchChange}
                        optionLabel="label"
                        placeholder="Select a Branch"
                        className="w-full md:w-14rem"
                        />

                </div>
                <br/>
                {!isFileSelected ? (
                <FileUpload
                    mode="basic"
                    name="demo[]"
                    customUpload
                    uploadHandler={customUploadHandler}
                    accept=".csv,.xlsx"
                    chooseLabel="Choose file (xlsx)"
                    label="hello"
                  />):

                    (<Button label="Upload xlsx" icon="pi pi-upload" iconPos="right" style={{ marginLeft: 'auto',marginRight:'auto' }} onClick={uploadSelectedFile} loading={isUploading}/>)}
                    <br/><small id="text-help">
                    (Supported file formats : xlsx)
                    </small>
                    
                        
                </p>                       <br/><br/><br/>
                </div>   
        
    </div>
  )
}

export default UploadProductCSVPopup
